module.exports = __webpack_public_path__ + "img/6.d2e047e7.png";